


















































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Getter, Mutation, State } from 'vuex-class';
import Method from './Method.vue';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import LegendComponent from './Legend.vue';
import Parse from './Parse.vue';
import Badges from './Badges.vue';
import StatusBadge from '@/components/ui/StatusBadge.vue';
import PlatformSpecification from './PlatformSpecification.vue';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames, StoreMutations } from '@/templates/DataNames';
import { convertToHtmlHelper, isEmptyObject, onScroller, orderObject } from '@/heplers';
import { BadgesType, MethodType } from '@/templates/NewRoutes';
import { CodeExampleObservers } from '@/heplers/codeExampleObservers';
import { getLastNameHelper } from '@/heplers/stringHelpers';
import CodeExampleBody from '@/components/docs-main/code-rails-view/CodeExampleBody.vue';

@Component({
  components: {
    DocIcon,
    LegendComponent,
    Parse,
    Badges,
    StatusBadge,
    PlatformSpecification,
    Method,
    CodeExampleBody,
  },
})
export default class TutorialFolder extends Vue {
  @Getter('getContent') data: MethodType;
  @State('pageRendered') pageRendered: boolean;
  @Mutation(StoreMutations.SET_LISTENERS_STATE) setListeners: (listenersState: boolean) => void;
  @Mutation(StoreMutations.SET_CURRENT_ANCHOR) setAnchor: (anchor: string) => void;
  $refs!: {
    content: HTMLElement;
  };

  get getDescription(): string {
    return this.data?.description
      ? this.data.description
      : 'Build smart IVRs, launch automated call campaigns and make trigger outbound calls with our visual flow builder to improve customer experience in no time.';
  }

  /**
   * Собираем объект для alert блоков
   */
  get statusBadges() {
    if (!this.data?.attributes) return {};

    const allowedBadgeNames: BadgesType[] = Object.values(BadgesType);

    //  @ts-expect-error: Parameter 'allowedBadgeNames' implicitly has an 'any'
    const filter = (attributes, allowedBadgeNames) =>
      allowedBadgeNames.reduce((acc: any, name: any) => {
        if (attributes[name] && typeof attributes[name] === 'string') {
          acc[name] = attributes[name];
        }
        return acc;
      }, {});

    return filter(this.data?.attributes, allowedBadgeNames);
  }

  get orderedData() {
    return orderObject(this.data);
  }

  get isReferences() {
    return this.data.fqdn.split('.')[0] === 'references';
  }

  get isTypedef() {
    return (
      ['typedef', 'function'].includes(<string>this.data?.kind) ||
      (this.$route?.meta?.fqdn?.split('.')[1] === 'unitysdk' && this.data?.kind === 'events')
    );
  }

  beforeMount() {
    GlobalBus.off(GlobalBusNames.NEWLANGUAGEPACKLOADED);
    GlobalBus.off('anchorScroll');
  }

  public checkTargetLink(link: string) {
    return link.includes('http') ? '_blank' : '_self';
  }

  mounted() {
    // @ts-expect-error: 'Prism' refers to a UMD global, but the current file is a module. Consider adding an import instead
    // eslint-disable-next-line no-undef
    if (this.$refs.content) Prism.highlightAllUnder(this.$refs.content);
    this.setListeners(false);
    this.bindEvents();
    this.checkAnchor();
    setTimeout(() => {
      this.setListeners(true);
    }, 300);
  }

  @Watch('pageRendered')
  onPageRenderedChanged(val: boolean) {
    if (val) {
      this.initHandlers();
    }
  }

  initHandlers() {
    this.bindEvents();

    if (isEmptyObject(this.orderedData)) return;

    this.$nextTick(CodeExampleObservers.bindObservers);
  }

  // Подключаемся к слушателям
  bindEvents() {
    GlobalBus.on(GlobalBusNames.NEWLANGUAGEPACKLOADED, this.findAllLanguages);
    GlobalBus.on(GlobalBusNames.LEGENDOPTIONSSCROLL, this.scrollToAnchor);
  }

  scrollToAnchor(fqdn: string) {
    const hash = getLastNameHelper(fqdn);
    this.setAnchor(hash);

    onScroller(`#${hash}`);
  }

  checkAnchor() {
    const routeFqdn = `${this.$route.meta.fqdn}.${location.hash.replace('#', '')}`;
    this.scrollToAnchor(routeFqdn);
  }

  convertToHtml(mdString: string) {
    if (!mdString) return;

    return convertToHtmlHelper(mdString);
  }

  private findAllLanguages() {
    let resultObj: string[] = [];

    let firstChild: any = this.data!.children;

    if (!firstChild || !firstChild.length) return;

    firstChild = firstChild[0];

    if (firstChild.title && typeof firstChild.title === 'object')
      Object.keys(firstChild.title).forEach((lang: string) => resultObj.push(lang));
    if (resultObj.length > 0) GlobalBus.emit(GlobalBusNames.CHECKENABLEDLANGS, resultObj);
  }

  /** From Tutorial.vue **/
  showCodeExample(obj: any) {
    return obj.kind === 'content_source' && obj.title;
  }
}
